import { render } from "./DaIcon.vue?vue&type=template&id=1f9e8d16&ts=true"
import script from "./DaIcon.vue?vue&type=script&lang=ts"
export * from "./DaIcon.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__